'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (props, traits, keyframes) {
  var color = props.color,
      rotate = props.rotate,
      size = props.size,
      spin = props.spin,
      styles = props.styles;


  return {
    root: _extends({
      fill: traits.colors[color] || color,
      display: 'inline-block',
      width: size + 'em',
      height: size + 'em',
      transform: 'rotate(' + rotate + 'deg)',
      animation: spin && keyframes.spin + ' 1s linear infinite'
    }, styles)
  };
};

var keyframes = exports.keyframes = {
  spin: {
    '0%': {
      transform: 'rotate(0deg)'
    },
    '100%': {
      transform: 'rotate(360deg)'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/icon/styles.js
// module id = 839
// module chunks = 0